import React, { forwardRef, FC, useState, useImperativeHandle, useEffect } from 'react';
import { Drawer, Dropdown, MenuProps, Modal } from 'antd';
import styles from './MenuDrawer.module.scss';
import { languageDict, languageMenuItems } from '@/utils/constants';
import { AppState } from '@/store';
import { shallowEqual, useSelector } from 'react-redux';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { changeArea } from '@/store/slices/headerAndFooterSlice';
import classNames from 'classnames';
import Link from 'next/link';
import { useAppContext } from '@/hooks/AppContext';

const MenuDrawer: FC<any> = forwardRef(({ setIsClicked, header, footers, language, articleData, majorLinks }, ref) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const router = useRouter();
  const closeMenu = () => {
    setMenuOpen(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openMenu = () => {
    setMenuOpen(true);
  };

  const { areaKey, setAreaKey } = useAppContext();

  const [mobileMenuOpen, setMobileMenuOpen] = useState<any>({});
  const [lanOpen, setLanOpen] = useState(false);
  const [areaOpen, setAreaOpen] = useState(false);

  const handleLanOpen = (flag: boolean) => {
    setLanOpen(flag);
  };

  const changeLanguage = (e: any) => {
    setLanOpen(false);
    setIsClicked(false);
    if (
      (router.pathname == '/[category]/[article]' && articleData?.languages == 'CH_Only' && e.key == 'en') ||
      (router.pathname == '/[category]/[article]' && articleData?.languages == 'EN_Only' && e.key == 'zh')
    ) {
      showModal();
      return;
    }
    const safeUrl = encodeURI(`/${e.key}${location.pathname.replace(/^\/(zh|en)\b/, '')}${location.search}`);
    setMenuOpen(false);
    router.push(safeUrl);
  };

  const handleChangeArea = (e: any) => {
    setAreaKey(e.key);
    setAreaOpen(false);
  };

  useImperativeHandle(ref, () => ({ openMenu, closeMenu }));

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = (language: string) => {
    setIsModalOpen(false);
    language === 'en'
      ? router.push({
          pathname: '/en/blog',
        })
      : router.push({
          pathname: '/zh/blog',
        });
  };

  const footer: any = footers?.length > 0 ? footers[0] : {};

  const areaDict: any = {};
  const countryData: any = footer && footer.country_list && footer.country_list[0] ? footer.country_list[0] : {};
  const countryLinkList = countryData.country_link_list || [];
  const countryItemList =
    countryLinkList.length > 0
      ? countryLinkList.map((item: any) => {
          const country_link = item.country_link;
          if (country_link.link.href && country_link.link.title) {
            areaDict[country_link.link.href] = country_link.link.title;
          }
          return { label: country_link.link.title, key: country_link.link.href };
        })
      : [];

  const areaMenu: MenuProps = {
    items: countryItemList,
    selectedKeys: [areaKey],
    onClick: e => {
      setAreaKey(e.key);
      window.open(e.key, '_blank');
    },
  };

  let menuItems = [];
  let concatItems = [];
  const networkProductsKeys: any = {};
  let contactQues = [];

  if (header) {
    menuItems = header.navigation_sections.filter((item: any) => item?.major_grouping);

    menuItems[0]?.major_grouping?.modular_blocks?.forEach((item: any) => {
      if (!networkProductsKeys[item?.Sub_grouping?.sub_grouping_title] && item?.Sub_grouping?.sub_grouping_title) {
        networkProductsKeys[item?.Sub_grouping?.sub_grouping_title] = [item];
      } else if (item?.Sub_grouping?.sub_grouping_title) {
        networkProductsKeys[item?.Sub_grouping?.sub_grouping_title].push(item);
      }
    });

    concatItems = header.navigation_sections.filter((item: any) => item?.title_link);
  }

  useEffect(() => {
    setMobileMenuOpen({
      ...mobileMenuOpen,
      [`product-sub-${Object.keys(networkProductsKeys)[0]}`]: true,
    });
  }, []);

  const handleOpen = (e: any) => {
    setMobileMenuOpen({
      ...mobileMenuOpen,
      [e?.major_grouping?._metadata?.uid]: !mobileMenuOpen[e?.major_grouping?._metadata?.uid],
    });
  };

  const handleOpenChild = (e: any) => {
    setMobileMenuOpen({
      ...mobileMenuOpen,
      [e?.Sub_grouping?._metadata?.uid]: !mobileMenuOpen[e?.Sub_grouping?._metadata?.uid],
    });
  };

  const hanldeOpenDropDown = (uid: any) => {
    setMobileMenuOpen({
      ...mobileMenuOpen,
      [uid]: !mobileMenuOpen[uid],
    });
  };

  const handleOpenProduct = (key: any) => {
    setMobileMenuOpen({
      ...mobileMenuOpen,
      [key]: !mobileMenuOpen[key],
    });
  };

  const callOutBlocks = header ? header?.navigation_sections.filter((x: any) => x.callout_block) : [];
  let callOutBlock =
    callOutBlocks.length > 0
      ? callOutBlocks[0].callout_block.title_desktop && callOutBlocks[0].callout_block.button_url_desktop
        ? callOutBlocks[0]
        : {}
      : {};
  callOutBlock = callOutBlock?.callout_block;
  const foo = () => {
    return (
      <div className={styles.Footer_Wrapper}>
        <span>{countryData.pre_text}</span>
        <Dropdown
          trigger={['click']}
          onOpenChange={setAreaOpen}
          open={areaOpen}
          placement="topRight"
          dropdownRender={() => (
            <ul
              className={classNames(
                styles.Area_Options_Wrapper,
                language?.origin === 'zh' ? styles.Area_Options_Wrapper_ZH : styles.Area_Options_Wrapper_EN,
              )}
            >
              {countryItemList.map((item: any) => (
                <li
                  key={item.key}
                  className={classNames(styles.Area_Item, areaKey === item.key ? styles.Selected_Area : '')}
                  onClick={() => handleChangeArea(item)}
                >
                  <a href={item.key} target="_blank" rel="noopener noreferrer">
                    <span>{item.label}</span>
                    {areaKey === item.key && (
                      <>
                        <Image src="/blog/icon/Tick.svg" className={styles.Tick} alt="" width={11} height={9} />
                        <Image
                          src="/blog/icon/TickWhite.svg"
                          className={styles.Tick_White}
                          alt=""
                          width={11}
                          height={9}
                        />
                      </>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          )}
        >
          <span className={styles.Area_Menu}>
            <span className={styles.Area}>{areaDict[areaKey]}</span>
            <span className={styles.Sort_Icon}>
              <Image src="/blog/icon/Sort.svg" alt="" width={16} height={16} />
            </span>
          </span>
        </Dropdown>
      </div>
    );
  };

  const handleGA = (title: any, href: any) => {
    window?.dataLayer?.push({
      event: 'menuBar',
      buttonTitle: title,
      destinationUrl: href,
      pageURL: window.location.href,
      productName: title,
      componentName: 'header menu',
    });
  };
  return (
    <>
      <Drawer
        className={classNames(
          styles.Menu_Drawer,
          language?.origin === 'zh' ? styles.Menu_Drawer_ZH : styles.Menu_Drawer_EN,
        )}
        width="100%"
        placement="left"
        styles={{ header: { display: 'none' } }}
        onClose={closeMenu}
        open={menuOpen}
        footer={foo()}
        zIndex={999}
      >
        <div className={styles.Menu_Content}>
          <div className={styles.Option_Wrapper}>
            {majorLinks.map((item: any, menuIndex: number) => (
              <div key={item?.major_grouping?._metadata?.uid}>
                <div className={styles.Option_Items}>
                  <span className={styles.Option_Item_Title}>
                    {item?.major_group_link?.href ? (
                      <a
                        href={item?.major_grouping?.major_group_link?.href}
                        onClick={() => handleGA(item?.major_group_link?.title, item?.major_group_link?.href)}
                      >
                        {item?.major_group_link?.title}
                      </a>
                    ) : item?.dropdownLinks?.length > 0 ? (
                      <div className={styles.menu_drawer_dropdown_item}>
                        <span
                          className={styles.menu_drawer_dropdown_item_title}
                          onClick={() => handleGA(item?.major_group_link?.title, '')}
                        >
                          {item?.major_group_link?.title}
                        </span>
                        {mobileMenuOpen[item?._metadata?.uid] ? (
                          <Image
                            src="/blog/icon/Reduce.svg"
                            onClick={() => hanldeOpenDropDown(item?._metadata?.uid)}
                            className={styles.Reduce_Icon}
                            alt={''}
                            width={16}
                            height={16}
                          />
                        ) : (
                          <Image
                            src="/blog/icon/Plus.svg"
                            onClick={() => hanldeOpenDropDown(item?._metadata?.uid)}
                            className={styles.Add_Icon}
                            alt={''}
                            width={16}
                            height={16}
                          />
                        )}
                      </div>
                    ) : (
                      <span onClick={() => handleGA(item?.major_group_link?.title, '')}>
                        {item?.major_group_link?.title}
                      </span>
                    )}
                  </span>
                </div>
                {menuIndex !== 0 ? (
                  <>
                    {mobileMenuOpen[item?._metadata?.uid] ? (
                      <div
                        className={classNames(
                          styles.dropdown,
                          item?.dropdownLinks?.some((x: any) => x.siblings?.length) && styles.dropdown_with_gap16,
                        )}
                      >
                        {item?.dropdownLinks?.map((item: any, index: number) => {
                          return (
                            <div key={index}>
                              <a
                                href={item?.href || undefined}
                                title={item?.title}
                                target={item.isOpenInNewTab ? '_blank' : undefined}
                                className={classNames(
                                  styles.dropdown_item,
                                  !!item?.href && styles.dropdown_hover_hover_item,
                                )}
                              >
                                {item.icon?.url && (
                                  <Image
                                    src={item.icon?.url}
                                    alt={item?.title ?? ''}
                                    width={24}
                                    height={24}
                                    style={{ cursor: 'default' }}
                                  />
                                )}
                                <div
                                  className={classNames(
                                    item?.dropdownLinks?.some((x: any) => x.siblings?.length)
                                      ? styles.dropdown_item_sibling_title
                                      : styles.dropdown_item_title,
                                  )}
                                  dangerouslySetInnerHTML={{ __html: item?.title ?? '' }}
                                />
                              </a>

                              {item.siblings?.map((subItem: any, i: any) => {
                                return (
                                  <div key={index + i} className={styles.sibling}>
                                    <a
                                      href={subItem?.href || undefined}
                                      title={subItem?.title}
                                      target={subItem.isOpenInNewTab ? '_blank' : undefined}
                                      className={classNames(
                                        styles.sibling_item,
                                        !!subItem?.href && styles.dropdown_hover_hover_item,
                                      )}
                                    >
                                      <div
                                        className={classNames(styles.sibling_item_title)}
                                        dangerouslySetInnerHTML={{ __html: subItem?.title ?? '' }}
                                      />
                                    </a>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ''
                    )}
                  </>
                ) : (
                  <>
                    {Object.keys(networkProductsKeys).map((productItem: any, index: any) => (
                      <div className={styles.product_list} key={index}>
                        <div className={styles.product_category}>
                          {productItem}
                          {mobileMenuOpen[`product-sub-${productItem}`] ? (
                            <Image
                              src="/blog/icon/Reduce.svg"
                              onClick={() => handleOpenProduct(`product-sub-${productItem}`)}
                              className={styles.Reduce_Icon}
                              alt={''}
                              width={24}
                              height={24}
                            />
                          ) : networkProductsKeys[productItem]?.length > 0 ? (
                            <Image
                              src="/blog/icon/Plus.svg"
                              onClick={() => handleOpenProduct(`product-sub-${productItem}`)}
                              className={styles.Add_Icon}
                              alt={''}
                              width={24}
                              height={24}
                            />
                          ) : (
                            ''
                          )}
                        </div>
                        {mobileMenuOpen[`product-sub-${productItem}`] ? (
                          <div className={styles.Option_Child} key={index}>
                            {networkProductsKeys[productItem]?.length > 0 &&
                              networkProductsKeys[productItem]?.map((child: any, index: any) => (
                                <div key={child?.Sub_grouping?._metadata?.uid}>
                                  <div className={styles.Option_Child_Items}>
                                    <div className={styles.Option_Child_Items_Title}>
                                      <Image src={child?.Sub_grouping?.icon?.url} alt={''} height={24} width={24} />
                                      <span className={styles.Option_Child_Items_TEXT}>
                                        <a
                                          href={child?.Sub_grouping?.sub_grouping_link?.href}
                                          onClick={() =>
                                            handleGA(
                                              child?.Sub_grouping?.sub_grouping_title,
                                              child?.Sub_grouping?.sub_grouping_link?.href,
                                            )
                                          }
                                        >
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: child?.Sub_grouping?.sub_grouping_link?.title ?? '',
                                            }}
                                          />
                                        </a>
                                      </span>
                                    </div>
                                    {mobileMenuOpen[child?.Sub_grouping?._metadata?.uid] ? (
                                      <Image
                                        src="/blog/icon/Reduce.svg"
                                        onClick={() => handleOpenChild(child)}
                                        className={styles.Reduce_Icon}
                                        alt={''}
                                        width={16}
                                        height={16}
                                      />
                                    ) : child?.Sub_grouping?.items.length > 0 ? (
                                      <Image
                                        src="/blog/icon/Plus.svg"
                                        onClick={() => handleOpenChild(child)}
                                        className={styles.Add_Icon}
                                        alt={''}
                                        width={16}
                                        height={16}
                                      />
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {mobileMenuOpen[child?.Sub_grouping?._metadata?.uid] ? (
                                    <div className={styles.Option_Children_Item}>
                                      {child?.Sub_grouping?.items.map((childrenItem: any) => (
                                        <a
                                          className={styles.Option_Children_Item_link}
                                          key={childrenItem?._metadata?.uid}
                                        >
                                          <span>•</span>
                                          <a
                                            href={childrenItem?.link_item?.href}
                                            onClick={() =>
                                              handleGA(childrenItem?.link_item?.title, childrenItem?.link_item?.href)
                                            }
                                          >
                                            <div
                                              style={{ display: 'inline' }}
                                              dangerouslySetInnerHTML={{
                                                __html: childrenItem?.link_item?.title ?? '',
                                              }}
                                            />

                                            {childrenItem?.call_out_label ? (
                                              <span className={styles.Option_Children_Item_label}>
                                                {childrenItem?.call_out_label}
                                              </span>
                                            ) : (
                                              ''
                                            )}
                                          </a>
                                        </a>
                                      ))}
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              ))}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            ))}
            {callOutBlock && callOutBlock.title_desktop && callOutBlock.button_label ? (
              <div className={styles.Callout_Block}>
                <Image src={callOutBlock.icon_desktop?.url} width={30} height={30} alt={''} />
                <div className={styles.Callout_Block_Content}>
                  <div>{callOutBlock.title_desktop}</div>
                  <Link href={'https:/www.fwd.com.hk' + callOutBlock.button_url_desktop}>
                    <Image src="/blog/icon/ArrowRight.svg" width={20} height={18} alt={''} />
                    <span className={styles.Button_Label}>{callOutBlock.button_label}</span>
                  </Link>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>

          <div className={styles.Divider}></div>

          <div className={styles.Concat_Wrapper}>
            {concatItems.map((item: any) => (
              <div className={styles.Concat_Items} key={item?.title_link?._metadata?.uid}>
                <a
                  href={item?.title_link?.link?.href}
                  onClick={() => handleGA(item?.title_link?.link?.title, item?.title_link?.link?.href)}
                >
                  {item?.title_link?.link?.title}
                </a>
              </div>
            ))}
          </div>
        </div>
      </Drawer>
      <Modal
        className={classNames(
          styles.Header_Modal,
          language?.value === 'en' ? styles.Header_Modal_EN : styles.Header_Modal_ZH,
        )}
        width={632}
        centered
        open={isModalOpen}
        onOk={() => handleOk(language?.value)}
        onCancel={handleCancel}
        okText={language?.value == 'en' ? 'Explore' : '瀏覽更多'}
        maskClosable={false}
        cancelText={language?.value == 'en' ? 'Stay on page' : '繼續瀏覽'}
      >
        <h3 className={styles.Modal_Title}>
          {language?.value == 'en' ? 'This content might not be in your language' : '此內容可能沒有您想要的語言版本'}
        </h3>
        <p className={styles.Modal_Text}>
          {language?.value == 'en'
            ? 'We are currently working to have this content in your language. You can choose to stay on this page, or proceed to explore other relevant contents.'
            : '我們正在努力提供您的語言版本。您可以選擇留在此頁或繼續探索其他相關內容。'}
        </p>
      </Modal>
    </>
  );
});

export default MenuDrawer;
